import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";

// element-ui
import "@/assets/scss/element.scss";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";

Vue.use(ElementUI, { locale });

import "normalize.css";
import "animate.css";
import "@/assets/scss/base.scss";
import "@/assets/scss/helper.scss";
import "@/assets/scss/common.scss";
import "@/assets/scss/global.scss";

// axios
import axios from "./axios.js";
Vue.prototype.$axios = axios;

// lodash
import lodash from "lodash";
Vue.prototype.$_ = lodash;

// storage
import storage from "store";
Vue.prototype.$storage = storage;

// dayjs
import dayjs from "dayjs";
Vue.prototype.$dayjs = dayjs;

//swiper
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";

Vue.use(VueAwesomeSwiper);

let res = require.context("@/components", false, /z-(.*).vue$/);
res.keys().forEach((key) => {
  let name = key.replace("./", "");
  name = name.replace(".vue", "");
  Vue.component(name, res(key).default);
});

Vue.config.productionTip = false;

var ua = navigator.userAgent;
var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
var isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
var isAndroid = ua.match(/(Android)\s+([\d.]+)/);
var isMobile = isIphone || isAndroid;

if (isMobile) {
  var viewport = document.querySelector("meta[name=viewport]");
  viewport.setAttribute(
    "content",
    "target-densitydpi=device-dpi,width=375,user-scalable=no"
  );
}

new Vue({
  render: (h) => h(App),
  store,
  router,
}).$mount("#app");
